/* globals ga */
'use strict';

import $ from 'jquery';
import UserValidator from '@/js/modules/user_validator';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.register-form, .xhr-register-form', (e) => {
    let error = '';
    const $form = $(e.target);
    const email = $form.find('#user_email').val();
    const name = $form.find('#user_name').val();
    const password = $form.find('#user_password').val();
    const passwordConfirmation = $form.find('#user_password_confirmation').val();
    const $submit = $form.find('button[type=submit]');

    error = UserValidator.validateEmail(email);
    $form
      .find('label[for=user_email]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validateName(name);
    $form
      .find('label[for=user_name]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validatePassword(password);
    $form
      .find('label[for=user_password]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validatePasswordConfirmation(password, passwordConfirmation);
    $form
      .find('label[for=user_password_confirmation]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    if ($('.form-error:visible').length) {
      $('.form-error:visible:first').focus();
      return false;
    }

    // if no errros and availablitiy validation passed successfully
    if ($submit.hasClass('button-loading')) {
      return true;
    } else {
      $submit.addClass('button-loading').prop('disabled', true);

      $.post(
        '/auth/xhr_validate_availability',
        {
          email,
          name,
        },
        (data) => {
          $.each(data, (key, error) => {
            if (key === 'email') {
              // show ordinary login link on html page and login modal on questionnaire page
              const $originalLoginLink = $('.client-login-callout-link ');
              let $errorLoginLink;

              if (document.body.id === 'shareables-project-board') {
                $errorLoginLink =
                  '<a href="#" class="unavailabble-email-error-link">Login here</a>';
              } else if ($originalLoginLink.hasClass('questionnaire-show-login-modal')) {
                $errorLoginLink =
                  '<a href="#" class="unavailabble-email-error-link questionnaire-show-login-modal">Login here</a>';
              } else {
                $errorLoginLink = `<a href="${$originalLoginLink.attr(
                  'href'
                )}" class="unavailabble-email-error-link">Login here</a>`;
              }

              $form
                .find('label[for=user_email]')
                .html(`You already have an account. ${$errorLoginLink} instead`)
                .css('display', 'block');
              $form
                .find('.unavailabble-email-error-link')
                .attr('href', $('.auth-box__client-login-link').attr('href'));
            } else if (key === 'name') {
              $('label[for=user_name]').html(error).css('display', 'block');
            }
          });

          if ($('.form-error:visible').length) {
            $('.form-error:visible:first').focus();
            $submit.removeClass('button-loading').prop('disabled', false);
          } else {
            // used on client registration page
            if ($form.is('.register-form')) {
              if (typeof ga !== 'undefined') {
                ga('send', 'event', 'Register', 'Client Register', 'Client Register Page');
              }
              $form.submit();
              // used in questionnaire modal client registration
            } else if ($form.is('.xhr-register-form')) {
              const data = $('.xhr-register-form input')
                .get()
                .reduce((map, el) => ((map[el.name] = el.value), map), {});

              $.post(
                '/register',
                data,
                (_res) => {
                  if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'Register', 'Client Register', 'Client Register Page');
                  }
                  $('.project-form').submit();
                },
                'json'
              ).fail(() => {
                alert('Error. Could not create new account.');
                $submit.removeClass('button-loading').prop('disabled', false);
              });
            }
          }
        }
      );
    }

    return false;
  });
});
